import { atom } from 'recoil'

export const manageRecipientsState = atom({
  key: 'EmailSendingQueueManage__manageRecipientsState',
  default: {
    pageSize: 5,
    pageNumber: 1,
    filterBy: '',
    item: [],
    orderBy: 'asc',
    totalItems: null,
    isSearch: false
  }
})

export const modalDeleteRecipientsState = atom({
  key: 'EmailSendingQueueManage__modalDeleteRecipientsState',
  default: {
    show: false,
    idRecipient: 0
  }
})

export const modalSendingSegmentationState = atom({
  key: 'EmailSendingQueueManage__modalSendingSegmentationState',
  default: {
    show: false,
    loading: false,
    error: undefined,
    severity: undefined,
    queued: undefined,
    groups: [],
    excludedGroups: [],
    filters: [],
    section: 'groups',
    idMessage: undefined,
    idSending: undefined,
    simulationEnabled: false,
    simulationLoading: false,
    simulationLoaded: false,
    simulationResult: undefined,
    simulationDiff: undefined
  }
})
